{
    "title": "Investment Profile",
    "subtitle": "Please fill in the following fields to complete your investment profile",
    "input": {
        "primarysourceoffunds": "Primary Source of Funds",
        "primarysourceoffundsdescription": "Primary Source of Funds Description",
        "totalinvestableassets": "Total Investable Assets",
        "assetallocationtocrypto": "Asset Allocation to Crypto",
        "investmentexperiencecrypto": "Investment Experience in Crypto",
        "investmentstrategycrypto": "Investment Strategy in Crypto",
        "initialdepositsource": "Initial Deposit Source",
        "initialdepositsourcecryptodetails": "Initial Deposit Source - Crypto Details",
        "initialdepositsourcefiatdetails": "Initial Deposit Source - Fiat Details",
        "ongoingdepositsource": "Ongoing Deposit Source",
        "frequencyofcryptotransactions": "Frequency of Crypto Transactions",
        "cryptoinvestmentplans": "Crypto Investment Plans",
        "investmentproceedsuse": "Investment Proceeds Use",
        "expectedcryptoassets": "Expected Crypto Assets",
        "performtransferswithunhostedwallets": "Perform Transfers with Unhosted Wallets",
        "knownunhostedwalletaddresses": "Known Unhosted Wallet Addresses",
        "tradespermonth": "Trades per Month",
        "usdvalueofcrypto": "Total USD value of CRYPTO assets",
        "usdvalueoffiat": "Total USD value of FIAT assets",
        "frequencyoftransactions": "Frequency of Transactions",
        "monthlycryptoinvestmentdeposit": "Projected Monthly Digital Asset Deposit Amount",
        "monthlyinvestmentdeposit": "Projected Monthly Fiat Deposit Amount",
        "monthlycryptodeposits": "Projected Number of Total Monthly Digital Asset Deposit",
        "monthlydeposits": "Projected Number of Incoming Bank Wires",
        "monthlycryptoinvestmentwithdrawal": "Projected Monthly Digital Asset Withdrawal Volume",
        "monthlyinvestmentwithdrawal": "Projected Monthly Fiat Withdrawal Volume",
        "monthlycryptowithdrawals": "Projected Number of Total Monthly Digital Asset Withdrawal",
        "monthlywithdrawals": "Projected Number of Total Monthly Fiat Withdrawal",
        "tradeinternationally": "Trade Internationally",
        "tradejurisdictions": "Trade Jurisdictions",
        "totalassets": "Total Assets"
    }
}